const EventDetailAboutMoongate = () => (
  <div className="w-full px-0">
    <div className="text-2xl mb-4 capitalize dark:text-white">Moongate</div>
    <div className="dark:text-white text-black whitespace-pre-wrap font-medium">
      <p>
        Moongate (
        <a
          href="https://twitter.com/0xMoongate"
          target="_blank"
          rel="noreferrer"
          className="text-primary underline cursor-pointer"
        >
          @OxMoongate
        </a>
        ) is building the underlying technology to drive the mass adoption of
        smart tickets and memberships. Through our platform, brands and
        businesses can easily create customized NFT digital assets that
        seamlessly integrates into real world operation.
      </p>
      <br />
      <p>
        To date, we have worked with a broad range of conferences, F&B chains,
        retail brands, and hospitality groups with our technology
        implementation; our product has been used by tens of thousands of end
        users, and has proven to drive customer engagement and revenue.
      </p>
    </div>
  </div>
);

export default EventDetailAboutMoongate;
